// Binary
// Below types are allowing us to send one or more binary contents contained in other schema objects
// Will be sent more efficiently over the network
export var BlobRefType;
(function (BlobRefType) {
    // If this is set then there is no way to get the binary data
    BlobRefType[BlobRefType["None"] = 0] = "None";
    // When this is set value is URL we can simply call HTTPS GET to fetch binary data. This URL must be on the AL service allow-list.
    BlobRefType[BlobRefType["HttpsGetDownloadUrl"] = 1] = "HttpsGetDownloadUrl";
    // When this is set value is a blob coded location that can be used to retrieve the data from the Azure Blob Storage.
    // It is only valid for one pair of session key and userId.
    BlobRefType[BlobRefType["AlCodedLocation"] = 2] = "AlCodedLocation";
})(BlobRefType || (BlobRefType = {}));
// Document Open Type
// Represents the method with which the document was opened at the client
export var OpenType;
(function (OpenType) {
    // the document was newly created
    OpenType[OpenType["NewDocument"] = 0] = "NewDocument";
    // an old document opened for editing
    OpenType[OpenType["EditDocument"] = 1] = "EditDocument";
    // document to be viewed
    OpenType[OpenType["ViewOnlyDocument"] = 2] = "ViewOnlyDocument";
})(OpenType || (OpenType = {}));
export class GridConstants {
}
GridConstants.lowerIndexBound = 1;
GridConstants.maxNumberOfRows = 1048576;
GridConstants.maxNumberOfColumns = 16384;
GridConstants.firstColumnName = 'A';
GridConstants.lastColumnName = 'XFD';
//# sourceMappingURL=tiles.js.map